import { Chip, Stack } from "@mui/material";

export default function HistoryEntriesChips({ historyEntries }) {
  return (
    <>
      {historyEntries.map((entry, index) => (
        <Chip
          component="span"
          key={index}
          label={entry.type.name}
          variant="outlined"
          size="small"
        />
      ))}
    </>
  );
}
